export default __webpack_public_path__ + "static/media/restaurant.5904b70b.png";